export const sx = {
    root: {
        '&.absolute': {
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 5566666
        }
    },
    fullScreen:{
        position: 'fixed',
        left:'0',
        top:'0',
        bottom:'0',
        right:'0',
        height:'100vh',
        width:'100vw',
        zIndex :666666,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        backdropFilter: "blur(5px)"

    }
}